// =============================================================================
// src/features/analytics/analytics-secondary-markup.ts - Modulos mock leves.
// Os pacotes mock de relatorio + leitor executivo BR-319 + modal "Personalizar
// resumo" SAIRAM (2026-07-27/28): a aba Relatorios virou a biblioteca real de
// PDFs (analytics-report-library-markup.ts) e a aba Resumo de IA virou os
// Cards de Inteligencia Tatica. Aqui ficam so os modulos secundarios.
// =============================================================================

import { escapeHtml } from '../../app/dom';
import {
  OMAR_ANALYTICS_SECONDARY_MODULES,
  type OmarAnalyticsSecondaryModule,
} from './analytics-data';
import { buildAnalyticsIngestionViewMarkup } from './analytics-ingestion-markup';

/** Renderiza os modulos secundarios com mock funcional leve. Configuracoes (021)
 * ganha a versao REAL quando a config de ingestao chegou do Hasura. */
export function buildAnalyticsSecondaryModuleViewsMarkup(): string {
  return OMAR_ANALYTICS_SECONDARY_MODULES.map((secondaryModule) => {
    if (secondaryModule.moduleName === 'settings') {
      return buildAnalyticsIngestionViewMarkup() ?? analyticsSecondaryModuleMarkup(secondaryModule);
    }
    return analyticsSecondaryModuleMarkup(secondaryModule);
  }).join('');
}

function analyticsSecondaryModuleMarkup(secondaryModule: OmarAnalyticsSecondaryModule): string {
  return `<section class="u-analytics-module" data-analytics-module-view="${secondaryModule.moduleName}" aria-labelledby="analytics-${secondaryModule.moduleName}-title" hidden>
    <div class="u-analytics-secondary-shell"><section class="u-analytics-panel u-analytics-secondary-card">
      <span>${escapeHtml(secondaryModule.eyebrow)}</span><h2 id="analytics-${secondaryModule.moduleName}-title">${escapeHtml(secondaryModule.title)}</h2><p>${escapeHtml(secondaryModule.body)}</p>
      <button type="button" class="u-analytics-ai-filter" data-analytics-local-action="${escapeHtml(secondaryModule.actionLabel)}">${escapeHtml(secondaryModule.actionLabel)}</button>
    </section>${analyticsSecondaryChecklistMarkup()}</div>
  </section>`;
}

function analyticsSecondaryChecklistMarkup(): string {
  return `<aside class="u-analytics-secondary-list"><span>Estado do mock</span><p><i class="ti ti-circle-check"></i>Dados conectados ao recorte Omar Aziz</p><p><i class="ti ti-circle-check"></i>Pronto para demonstracao interna</p><p><i class="ti ti-circle-check"></i>Sem integracao externa nesta versao</p></aside>`;
}
